import { render, staticRenderFns } from "./inputs.vue?vue&type=template&id=0d5f6fa5&scoped=true&"
import script from "./inputs.vue?vue&type=script&lang=js&"
export * from "./inputs.vue?vue&type=script&lang=js&"
import style0 from "./inputs.vue?vue&type=style&index=0&id=0d5f6fa5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5f6fa5",
  null
  
)

export default component.exports